export const privacyPolicyURL = "/privacy-policy";
export const termsOfUseURL = "/terms-of-use";
export const cookiePolicyURL = "/cookie-policy";
export const nonDiscriminationPolicyURL = "/non-discrimination-policy";
export const DMCAURL = "/dmca";
